import axios from 'axios';

const ACCESS_KEY = import.meta.env.VITE_UNSPLASH_ACCESS_KEY;
const BASE_URL = 'https://api.unsplash.com/search/photos';

export const getRegionImage = async (query) => {
  if (!query) return null;

  try {
    // On cherche une photo de paysage au Québec correspondant au nom de la région
    const response = await axios.get(BASE_URL, {
      params: {
        client_id: ACCESS_KEY,
        query: `Quebec ${query} nature landscape`, // Mots-clés pour cibler de belles vues
        orientation: 'landscape',
        per_page: 1
      }
    });

    // Si on trouve une image, on renvoie son URL
    if (response.data.results && response.data.results.length > 0) {
      return response.data.results[0].urls.regular;
    }
    
    return null; // Aucune image trouvée
  } catch (error) {
    console.error("Erreur Unsplash:", error);
    return null;
  }
};
